import HTTP from '@rocketfid/api'

const state = {
  items: [],
  itemMoving: null
}

// getters
const getters = {
  medias: (state) => {
    return state.items
  },
  getByLibrary: (state) => ({ library }) => {
    return state.items.filter(item => (item.idlibrary === library.id))
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  mediaMoving: (state) => {
    return state.itemMoving
  }
}

// actions
const actions = {
  startMove ({ commit }, media) {
    commit('SET_MEDIA_MOVING', { media: media })
  },
  loadMedias ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .media.getAll(id)
      .then((medias) => {
        commit('ADD_MEDIA_ITEMS', { items: medias })
        return medias
      })
  },

  resetMedias ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_MEDIA_ITEMS')
      resolve()
    })
  },

  addMedia ({ commit, rootGetters }, { libraryId, media }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .media.create(libraryId, media)
      .then((media) => {
        commit('ADD_MEDIA_ITEM', { item: media })
        return media
      })
  },

  addWaveMedia ({ rootGetters }, { media }) {
    let sitekey = rootGetters['account/currentSitekey']
    let formData = new FormData()
    formData.append('file', media)
    return HTTP
      .setInstance(sitekey)
      .axios.post(process.env.API + '/wave/media/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => res.data)
      .then((media) => {
        return media
      })
  },

  removeMedia ({ commit, rootGetters }, { media }) {
    let sitekey = rootGetters['account/currentSitekey']
    return HTTP
      .setInstance(sitekey)
      .media.delete(media)
      .then((media) => {
        commit('REMOVE_MEDIA_ITEM', { item: media })
        return media
      })
  }
}

// mutations
const mutations = {
  SET_MEDIA_MOVING: (state, { media }) => {
    state.itemMoving = media
  },
  ADD_MEDIA_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },
  ADD_MEDIA_ITEM: (state, { item }) => {
    state.items.push(item)
  },
  RESET_MEDIA_ITEMS: (state) => {
    state.items = []
  },

  REMOVE_MEDIA_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/medias.js